export const matches = (
  label: string,
  value: string | null | undefined,
  searchQuery: string | null | undefined
): boolean => {
  if (!searchQuery) return true;
  const query = searchQuery.toLowerCase();
  const labelMatch = label.toLowerCase().includes(query);
  const valueMatch = value?.toLowerCase().includes(query) ?? false;
  return labelMatch || valueMatch;
};
